import React, { useState, useReducer, useEffect, useContext } from "react";
import {
  Alert,
  Card,
  Col,
  Row,
  Table,
  Badge,
  Image,
  Button,
  Dropdown,
  NavDropdown,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { BreadcrumbContext } from "../../../contexts/BreadcrumbContext";
import queryString from "query-string";
import moduleConfig from "./moduleConfig";
import axios from "../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../config/toastNotification";
import DashboardLayout from "../../UI/layouts/DashboardLayout";
import { ContainerLoading } from "../../UI/loading/ContainerLoading";
import BlockErrorMessage from "../../UI/errorMessages/BlockErrorMessage";
import ModuleHeader from "../../UI/modules/views/partials/common/ModuleHeader";
import FormErrorMessage from "../../UI/errorMessages/FormErrorMessage";
import useConfirm from "../../../HOC/custom/useConfirm";
import ListingFooter from "./partials/listing/ListingFooter";
import SearchArea from "./partials/listing/SearchArea";
import { listingReducer, listingInitialState } from "./reducers/listingReducer";
import ModuleDisplayBoolean from "../../UI/modules/fieldsDisplay/ModuleDisplayBoolean";
import ModuleDisplayDateTime from "../../UI/modules/fieldsDisplay/ModuleDisplayDateTime";
import SendEmailTo from "../../UI/mix/SendEmailTo";
import SendEmailToSelected from "../../UI/mix/SendEmailToSelected";
import { AdditionalRequestAcceptModal } from "./partials/listing/AdditionalRequestAcceptModal";
import { AdditionalRequestRejectModal } from "./partials/listing/AdditionalRequestRejectModal";
import { RegisterNewModal } from "./partials/listing/RegisterNewModal";
import {
  ApprovalBadge,
  checkParticipantsLimitReached,
  checkStatusOfAll,
  isActivityFree,
  isAllowedToCancel,
} from "../../../helpers/CommonHelper";
import { AddMoreParticipantsModal } from "./partials/listing/AddMoreParticipantsModal";
import SendEmailToFiltered from "../../UI/mix/SendEmailToFiltered";
import Papa from "papaparse";
const customButtonsForItems = [
  // {
  //   label: "Change Password",
  //   className: "fas fa-key",
  //   url: "change-password"
  // }
];

const ActivityRegistrationsListing = () => {
  let { id } = useParams();

  const { setBreadcrumb } = useContext(BreadcrumbContext);
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState,
  );
  const [isEmailSelected, setIsEmailSelected] = useState([]);
  const [isCheck, setIsCheck] = useState([]);
  const [isCheckAll, setIsCheckAll] = useState(false);
  const [actionItem, setActionItem] = useState(null);
  const [udpateItem, setUdpateItem] = useState(null);
  const [screen, setScreen] = useState({
    loading: true,
    status: "fetching",
    activityStatus: "fetching",
    members: null,
    item: null,
  });
  const [
    showAdditionalRequestAcceptModal,
    setShowAdditionalRequestAcceptModal,
  ] = useState(false);
  const [
    showAdditionalRequestRejectModal,
    setShowAdditionalRequestRejectModal,
  ] = useState(false);
  const [showRegisterNewModal, setShowRegisterNewModal] = useState(false);
  const [showAddMoreParticipantsModal, setShowAddMoreParticipantsModal] =
    useState(false);
  const { search } = useLocation();
  const [appliedFilters, setAppliedFilters] = useState(
    queryString.parse(search),
  );
  if (appliedFilters.limit) {
    moduleConfig.perPageItems = appliedFilters.limit;
  }

  let breadcrumbs = {
    activityListing: {
      label: "Activities",
      url: `/activities`,
    },
    activityDetails: {
      label: "Details",
      url: `/activities/${id}`,
    },
    listing: {
      label: moduleConfig.title,
      url: `/${moduleConfig.url}`,
    },
  };

  let history = useNavigate();
  const { confirm } = useConfirm();
  const setFilter = (name, value) => {
    console.log(`setFilter called with ${name}, ${value}`);
    let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

    if (value) {
      newAppliedFilters[name] = value;
    } else {
      delete newAppliedFilters[name];
    }

    if (name !== "page") {
      delete newAppliedFilters["page"];
    }

    if (name === "limit" || name === "page") {
      setIsEmailSelected([]);
      setIsCheck([]);
      setIsCheckAll(false);
    }

    let newURL = queryString.stringify(newAppliedFilters);
    history({ search: newURL });
    setAppliedFilters(newAppliedFilters);
  };
  const loadActivity = async () => {
    try {
      const res = await axios.get(`activities/${id}`); //
      if (res && (res.status === 200 || res.status === 201)) {
        setScreen((prevState) => ({
          ...prevState,
          loading: false,
          activityStatus: "fetched",
          item: res.data?.item,
        }));
      }
    } catch (error) {
      setScreen((prevState) => ({
        ...prevState,
        loading: false,
        activityStatus: "fetchError",
      }));
    }
  };
  const loadItems = async () => {
    listingDispatch({
      type: "FETCH_REQUEST",
    });

    try {
      const res = await axios.get(`${moduleConfig.url}/${id}${search}`); //
      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: res.data,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    }
  };
  const loadMembersListForRegistration = async () => {
    setScreen((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const res = await axios.get(
        `activity-registrations/members-list-for-registration/${id}`,
      ); //
      console.log(res.status);
      if (res && res.status) {
        setScreen((prevState) => ({
          ...prevState,
          loading: false,
          status: "fetched",
          members: res.data?.items,
        }));
      }
    } catch (error) {
      setScreen((prevState) => ({
        ...prevState,
        loading: false,
        status: "fetchError",
      }));
    }
  };
  const resetFilters = () => {
    //console.log(`resetFilters called`)
    let newAppliedFilters = JSON.parse(JSON.stringify(appliedFilters));

    moduleConfig.perPageItems = 10;
    delete newAppliedFilters["limit"];
    delete newAppliedFilters["status"];
    delete newAppliedFilters["attended"];
    delete newAppliedFilters["q"];

    let newURL = queryString.stringify(newAppliedFilters);
    history({ search: newURL });
    //console.log(newAppliedFilters);
    setAppliedFilters(newAppliedFilters);
  };

  useEffect(() => {
    loadItems();
    loadActivity();
  }, [search]);
  useEffect(() => {
    loadActivity();
  }, []);

  useEffect(() => {
    setBreadcrumb([
      breadcrumbs.activityListing,
      breadcrumbs.activityDetails,
      breadcrumbs.listing,
    ]);
  }, []);

  const handleSelectAll = () => {
    setIsCheckAll(!isCheckAll);

    if (listingState.data.items && listingState.data.items.length) {
      setIsCheck(listingState.data.items.map((li) => li._id));
    }

    if (listingState.data.items && listingState.data.items.length) {
      setIsEmailSelected(listingState.data.items.map((li) => li.email));
    }

    if (isCheckAll) {
      setIsCheck([]);
      setIsEmailSelected([]);
    }
  };

  const handleCheckBoxClick = (e) => {
    let email = e.target.attributes.email.value;
    const { id, checked } = e.target;
    setIsCheck([...isCheck, id]);
    setIsEmailSelected([...isEmailSelected, email]);
    if (!checked) {
      setIsCheck(isCheck.filter((item) => item !== id));
      setIsEmailSelected(isEmailSelected.filter((item) => item !== email));
    }
    setIsCheckAll(false);
  };

  const download = (type) => {
    console.log("Download Click");

    axios
      .post(
        `/activity-registrations/download/${id}`,
        {
          type,
          ids: isCheck,
          appliedFilters: type === "appliedFilters" ? appliedFilters : null,
        },
        // { responseType: 'blob' }
      )
      .then(function (response) {
        console.log(response);

        let blob = new Blob([response.data], { type: "text/csv" }),
          downloadUrl = window.URL.createObjectURL(blob),
          filename = "registrations.csv";
        //  disposition = response.headers["content-disposition"];

        // if (disposition && disposition.indexOf("attachment") !== -1) {
        //   let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
        //     matches = filenameRegex.exec(disposition);

        //   if (matches != null && matches[1]) {
        //     filename = matches[1].replace(/['"]/g, "");
        //   }
        // }

        let a = document.createElement("a");
        if (typeof a.download === "undefined") {
          window.location.href = downloadUrl;
        } else {
          a.href = downloadUrl;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
        }
      });
  };

  const showModal = (item, type) => {
    setActionItem(item);
    if (type === "accept") {
      setShowAdditionalRequestAcceptModal(true);
    } else if (type === "reject") {
      setShowAdditionalRequestRejectModal(true);
    }
  };
  const confirmAndRemoveRegistration = async (data) => {
    const isConfirmed = await confirm(
      `Do you really want to remove this registration?`,
    );

    if (isConfirmed) {
      removeRegistration(data);
    }
  };
  const removeRegistration = async (data) => {
    setScreen((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      const res = await axios.post(
        `activity-registrations/cancel-registration`,
        data,
      );
      setScreen((prevState) => ({
        ...prevState,
        loading: false,
      }));
      loadItems();
      // detailsDispatch({
      //     type: "DELETE_SUCCESS"
      // });
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Registration cancelled successfully.`,
        type: "success",
      });
    } catch (error) {
      setScreen((prevState) => ({
        ...prevState,
        loading: false,
      }));
      toast.addNotification({
        ...toastNotification,
        title: "Alert!",
        message: `Registration cancelled successfully.`,
        type: "danger",
      });
    }
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
    const reader = new FileReader();
    reader.onload = (event) => {
      const csvText = event.target.result;
      const parsedData = Papa.parse(csvText, { header: true }).data;
      setCsvData(parsedData);

      // Now that csvData is updated, you can safely use it
      console.log(csvData); // This should now log the updated data

      // Assuming history is imported from react-router-dom
      //
    };
    reader.readAsText(event.target.files[0]);
  };

  useEffect(() => {
    if (csvData && csvData.length > 0) {
      history(`/activity-registrations/import/${id}`, { state: csvData });
    }
  }, [csvData]);

  // convenience flags for the grouped/color-coded table header + body
  const activity = listingState?.data?.activity;
  const showPartnerGroup = activity && activity.partnerAllowed === "1";
  const showGuestGroup = activity && activity.guestAllowed === "1";
  const showKidsGroup = activity && activity.kidsAllowed === "1";
  const guestRequiresApproval =
    screen?.item?.guestFeaturesSettings?.requireAdminApproval === "1";
  const kidsRequiresApproval =
    screen?.item?.kidsFeaturesSettings?.requireAdminApproval === "1";

  return (
    <DashboardLayout>
      {(listingState.isLoading || screen.loading) && <ContainerLoading />}

      {listingState.status !== "fetching" &&
        screen.activityStatus === "fetched" && (
          <>
            {listingState.error && listingState.status === "fetchFailed" ? (
              <BlockErrorMessage error={listingState.error} />
            ) : (
              <>
                <ModuleHeader
                  moduleTitle={moduleConfig.title}
                  subName={listingState.data.activity.title}
                  moduleUrl={moduleConfig.url}
                >
                  <div className="moduleHeaderTopButtons">
                    {/* <div className="file-input-container me-1 mb-2">
                    <label htmlFor="file-upload" className="custom-file-upload">
                      Import Users
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      accept=".csv"
                      onChange={(e) => handleFileChange(e)}
                    />
                  </div> */}

                    <Button
                      variant="primary me-1"
                      onClick={() => {
                        setShowRegisterNewModal(true);
                        loadMembersListForRegistration();
                      }}
                    >
                      Register New
                    </Button>

                    {listingState.data &&
                      listingState.data.pagination &&
                      listingState.data.pagination.totalItems > 0 && (
                        <>
                          <div className="nav-item dropdown  text-white">
                            <NavDropdown
                              className="dropButton mr-1"
                              title={
                                <>
                                  <i className="fa fa-envelope me-1"> </i> Email
                                  to{" "}
                                </>
                              }
                              id="basic-nav-dropdown"
                            >
                              <p className="dropdown-item  mb-1">
                                <SendEmailTo
                                  heading="Send Email to All"
                                  buttonTitle="All Registrations"
                                  apiURL="activity-registrations"
                                  sendEmailTo="all"
                                  activityId={id}
                                />
                              </p>

                              <p className="dropdown-item mb-1">
                                <SendEmailToFiltered
                                  heading="Send Email to Filtered Registrations"
                                  buttonTitle="Filtered Registrations"
                                  apiURL="activity-registrations"
                                  appliedFilters={appliedFilters}
                                  activityId={id}
                                />
                              </p>

                              <p className="dropdown-item mb-1">
                                <SendEmailToSelected
                                  buttonTitle="Selected Registrations"
                                  apiURL="activity-registrations"
                                  emails={isEmailSelected}
                                  activityId={id}
                                />
                              </p>
                            </NavDropdown>
                          </div>

                          <Dropdown className="">
                            <Dropdown.Toggle
                              variant="primary"
                              className="border"
                              id="dropdown-basic"
                            >
                              <i className="fa fa-download"> </i> Download
                              &nbsp;
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                              <Dropdown.Item onClick={() => download("all")}>
                                All Registrations
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => download("appliedFilters")}
                              >
                                Filtered Registrations
                              </Dropdown.Item>
                              <Dropdown.Item
                                disabled={
                                  isCheck && isCheck.length > 0 ? false : true
                                }
                                onClick={() => download("selected")}
                              >
                                Selected Registrations
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </>
                      )}
                  </div>
                </ModuleHeader>

                <div className="listingPage">
                  {listingState.data &&
                  listingState.data.pagination &&
                  listingState.data.pagination.totalItems > 0 ? (
                    <>
                      {/* Search Area */}
                      <SearchArea
                        moduleConfig={moduleConfig}
                        setFilter={setFilter}
                        appliedFilters={appliedFilters}
                        resetFilters={resetFilters}
                        isActivityFree={isActivityFree(screen.item)}
                      />

                      {/* Listing */}
                      <section className="content listing">
                        {listingState.error && (
                          <FormErrorMessage error={listingState.error} />
                        )}

                        {!listingState.data.items ||
                        listingState.data.items.length <= 0 ? (
                          <Alert variant="warning">
                            No records found.{" "}
                            <Alert.Link href="#" onClick={() => resetFilters()}>
                              <i className="fas fa-times" /> Reset Filters
                            </Alert.Link>
                            .
                          </Alert>
                        ) : (
                          <>
                            {listingState.data.items &&
                              listingState.data.items.length && (
                                <>
                                  <div className="registrationTable m-0 p-0 mt-2">
                                    <style>{`
                                      .registrationTable table,
                                      .registrationTable th{
                                        border: 1px solid #c7c9cc;
                                      }

                                      .registrationTable thead th {
                                        padding: 8px 10px;
                                        vertical-align: middle;
                                        line-height: 1.3;
                                      }

                                      .registrationTable thead tr:first-child th {
                                        font-size: 12px;
                                        font-weight: 600;
                                        letter-spacing: 0.02em;
                                        text-transform: uppercase;
                                      }

                                      .registrationTable thead tr:last-child th {
                                        font-size: 12px;
                                        font-weight: 400;
                                        color: #5f6368;
                                        text-transform: none;
                                        padding-top: 6px;
                                        padding-bottom: 6px;
                                      }

                                      .registrationTable thead th[rowspan="2"] {
                                        font-size: 13px;
                                        font-weight: 600;
                                        text-transform: none;
                                        letter-spacing: normal;
                                      }

                                      .registrationTable table {
                                        position: relative;
                                      }
                                      .registrationTable thead th {
                                        position: sticky;
                                        top: 0;
                                        z-index: 1;
                                      }

                                      .regCol-member { background: #E6F1FB; color: #0C447C; }
                                      .regCol-partner { background: #D6F3EA; color: #085041; }
                                      .regCol-guest { background: #FBEAF0; color: #4B1528; }
                                      .regCol-kids { background: #EEEDFE; color: #26215C; }

                                      tbody .regCol-member,
                                      tbody .regCol-partner,
                                      tbody .regCol-guest,
                                      tbody .regCol-kids {
                                        background: transparent;
                                        color: inherit;
                                      }
                                    `}</style>
                                    <Table bordered size="sm">
                                      <thead>
                                        <tr>
                                          <th
                                            rowSpan={2}
                                            className="regCol-member"
                                          >
                                            <input
                                              className="selectAll"
                                              type="checkbox"
                                              name="selectAll"
                                              id="selectAll"
                                              onChange={handleSelectAll}
                                              checked={isCheckAll}
                                            />
                                          </th>
                                          <th
                                            rowSpan={2}
                                            className="regCol-member"
                                          >
                                            #
                                          </th>
                                          <th
                                            rowSpan={2}
                                            className="regCol-member"
                                          >
                                            Member Name
                                          </th>
                                          <th
                                            rowSpan={2}
                                            className="text-center regCol-member"
                                          >
                                            Member Status
                                          </th>

                                          {showPartnerGroup && (
                                            <th
                                              colSpan={2}
                                              className="text-center regCol-partner"
                                            >
                                              Partner
                                            </th>
                                          )}

                                          {showGuestGroup && (
                                            <th
                                              colSpan={
                                                guestRequiresApproval ? 3 : 2
                                              }
                                              className="text-center regCol-guest"
                                            >
                                              Guest
                                            </th>
                                          )}

                                          {showKidsGroup && (
                                            <th
                                              colSpan={
                                                kidsRequiresApproval ? 3 : 2
                                              }
                                              className="text-center regCol-kids"
                                            >
                                              Kids
                                            </th>
                                          )}

                                          <th
                                            rowSpan={2}
                                            className="text-center"
                                          >
                                            Actions
                                          </th>
                                          <th rowSpan={2}>Admin Notes</th>
                                          <th
                                            rowSpan={2}
                                            className="text-center"
                                          >
                                            Registration Time
                                          </th>
                                        </tr>
                                        <tr>
                                          {showPartnerGroup && (
                                            <>
                                              <th className="text-center regCol-partner regCol-sub">
                                                Participating
                                              </th>
                                              <th className="text-center regCol-partner regCol-sub">
                                                Status
                                              </th>
                                            </>
                                          )}

                                          {showGuestGroup && (
                                            <>
                                              <th className="text-center regCol-guest regCol-sub">
                                                Participating
                                              </th>
                                              {guestRequiresApproval && (
                                                <th className="text-center regCol-guest regCol-sub">
                                                  Admin Approval
                                                </th>
                                              )}
                                              <th className="text-center regCol-guest regCol-sub">
                                                Status
                                              </th>
                                            </>
                                          )}

                                          {showKidsGroup && (
                                            <>
                                              <th className="text-center regCol-kids regCol-sub">
                                                Participating
                                              </th>
                                              {kidsRequiresApproval && (
                                                <th className="text-center regCol-kids regCol-sub">
                                                  Admin Approval
                                                </th>
                                              )}
                                              <th className="text-center regCol-kids regCol-sub">
                                                Status
                                              </th>
                                            </>
                                          )}
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {listingState.data.items.map(
                                          (item, index) => {
                                            return (
                                              <>
                                                <tr
                                                  index={index}
                                                  className={
                                                    item.additionalRequests &&
                                                    item.additionalRequests
                                                      .length <= 0 &&
                                                    "borderBottom"
                                                  }
                                                >
                                                  <td
                                                    rowSpan={
                                                      item.additionalRequests &&
                                                      item.additionalRequests
                                                        .length > 0 &&
                                                      item.additionalRequests
                                                        .length + 1
                                                    }
                                                  >
                                                    <input
                                                      type="checkbox"
                                                      className="selectAll"
                                                      id={item._id}
                                                      email={item.member.email}
                                                      name={item._id}
                                                      onChange={
                                                        handleCheckBoxClick
                                                      }
                                                      checked={isCheck.includes(
                                                        item._id,
                                                      )}
                                                    />
                                                  </td>
                                                  <td
                                                    rowSpan={
                                                      item.additionalRequests &&
                                                      item.additionalRequests
                                                        .length > 0 &&
                                                      item.additionalRequests
                                                        .length + 1
                                                    }
                                                  >
                                                    {index + 1}
                                                  </td>
                                                  <td
                                                    rowSpan={
                                                      item.additionalRequests &&
                                                      item.additionalRequests
                                                        .length > 0 &&
                                                      item.additionalRequests
                                                        .length + 1
                                                    }
                                                  >
                                                    <Button
                                                      href={`/members/${item.memberId}`}
                                                      variant="link"
                                                    >
                                                      {item.member.fullName
                                                        ? item.member.fullName
                                                        : "-"}
                                                    </Button>
                                                  </td>

                                                  <td className="text-center">
                                                    <>
                                                      {item.memberStatus ===
                                                      "1" ? (
                                                        <Badge bg="success">
                                                          Confirmed
                                                        </Badge>
                                                      ) : item.memberStatus ===
                                                        "0" ? (
                                                        <Badge
                                                          bg="warning"
                                                          text="dark"
                                                        >
                                                          Payment Pending
                                                        </Badge>
                                                      ) : (
                                                        "-"
                                                      )}
                                                    </>
                                                  </td>

                                                  {/* Partner group */}
                                                  {showPartnerGroup && (
                                                    <>
                                                      <td className="text-center">
                                                        <>
                                                          {item.partnerParticipating ===
                                                          "1" ? (
                                                            <Badge bg="success">
                                                              Yes
                                                            </Badge>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </>
                                                      </td>
                                                      <td className="text-center">
                                                        <>
                                                          {item.partnerStatus ===
                                                          "1" ? (
                                                            <Badge bg="success">
                                                              Confirmed
                                                            </Badge>
                                                          ) : item.partnerParticipating ===
                                                              "1" &&
                                                            item.payment
                                                              ?.partnerParticipationFee >
                                                              0 ? (
                                                            <Badge
                                                              bg="warning"
                                                              text="dark"
                                                            >
                                                              Payment Pending
                                                            </Badge>
                                                          ) : item.partnerParticipating ===
                                                            "1" ? (
                                                            <Badge
                                                              bg="warning"
                                                              text="dark"
                                                            >
                                                              Pending
                                                            </Badge>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </>
                                                      </td>
                                                    </>
                                                  )}

                                                  {/* Guest group */}
                                                  {showGuestGroup && (
                                                    <>
                                                      <td className="text-center">
                                                        <>
                                                          {item.guestParticipating ===
                                                          "1" ? (
                                                            <Badge bg="success">
                                                              Yes (
                                                              {
                                                                item.NumberOfGuestParticipating
                                                              }
                                                              )
                                                            </Badge>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </>
                                                      </td>
                                                      {guestRequiresApproval && (
                                                        <td className="text-center">
                                                          -
                                                        </td>
                                                      )}
                                                      <td className="text-center">
                                                        {item.isApprovedByAdmin ===
                                                        "1" ? (
                                                          <>
                                                            {item.guestStatus ===
                                                            "1" ? (
                                                              <Badge bg="success">
                                                                Confirmed
                                                              </Badge>
                                                            ) : item.guestParticipating ===
                                                                "1" &&
                                                              item.payment
                                                                ?.guestParticipationFee >
                                                                0 ? (
                                                              <Badge
                                                                bg="warning"
                                                                text="dark"
                                                              >
                                                                Payment Pending
                                                              </Badge>
                                                            ) : item.guestParticipating ===
                                                              "1" ? (
                                                              <Badge
                                                                bg="warning"
                                                                text="dark"
                                                              >
                                                                Pending
                                                              </Badge>
                                                            ) : (
                                                              "-"
                                                            )}
                                                          </>
                                                        ) : (
                                                          "-"
                                                        )}
                                                      </td>
                                                    </>
                                                  )}

                                                  {/* Kids group */}
                                                  {showKidsGroup && (
                                                    <>
                                                      <td className="text-center">
                                                        <>
                                                          {item.kidsParticipating ===
                                                          "1" ? (
                                                            <Badge bg="success">
                                                              Yes (
                                                              {
                                                                item.NumberOfKidsParticipating
                                                              }
                                                              )
                                                            </Badge>
                                                          ) : (
                                                            "-"
                                                          )}
                                                        </>
                                                      </td>
                                                      {kidsRequiresApproval && (
                                                        <td className="text-center">
                                                          -
                                                        </td>
                                                      )}
                                                      <td className="text-center">
                                                        {item.isApprovedByAdmin ===
                                                        "1" ? (
                                                          <>
                                                            {item.kidsStatus ===
                                                            "1" ? (
                                                              <Badge bg="success">
                                                                Confirmed
                                                              </Badge>
                                                            ) : item.kidsParticipating ===
                                                                "1" &&
                                                              item.payment
                                                                ?.kidsParticipationFee >
                                                                0 ? (
                                                              <Badge
                                                                bg="warning"
                                                                text="dark"
                                                              >
                                                                Payment Pending
                                                              </Badge>
                                                            ) : item.kidsParticipating ===
                                                              "1" ? (
                                                              <Badge
                                                                bg="warning"
                                                                text="dark"
                                                              >
                                                                Pending
                                                              </Badge>
                                                            ) : (
                                                              "-"
                                                            )}
                                                          </>
                                                        ) : (
                                                          "-"
                                                        )}
                                                      </td>
                                                    </>
                                                  )}

                                                  <td
                                                    valign="middle"
                                                    className=""
                                                  >
                                                    {item.isCreatedByAdmin ===
                                                      "1" &&
                                                      (item.status === "0" ||
                                                        (item.status === "1" &&
                                                          item.payment
                                                            .paidAmount <=
                                                            0)) && (
                                                        <div className="d-flex align-items-center justify-content-center">
                                                          <Link
                                                            title="Cancel"
                                                            onClick={() =>
                                                              confirmAndRemoveRegistration(
                                                                {
                                                                  activityId:
                                                                    id,
                                                                  memberId:
                                                                    item.memberId,
                                                                  registrationId:
                                                                    item._id,
                                                                  additionalRequestId:
                                                                    "",
                                                                },
                                                              )
                                                            }
                                                            className="btn btn-danger acceptButton  border me-1"
                                                          >
                                                            <i className="fas fa-times text-white me-1"></i>{" "}
                                                            <span className="text-white">
                                                              Cancel{" "}
                                                            </span>
                                                          </Link>
                                                        </div>
                                                      )}
                                                    {checkStatusOfAll(item) &&
                                                      !checkParticipantsLimitReached(
                                                        item,
                                                        screen.item,
                                                      ) && (
                                                        <div className="d-flex align-items-center justify-content-center">
                                                          <Link
                                                            title="add more participants"
                                                            onClick={() => {
                                                              setShowAddMoreParticipantsModal(
                                                                true,
                                                              );
                                                              setUdpateItem(
                                                                item,
                                                              );
                                                            }}
                                                            className="btn btn-success acceptButton  border me-1"
                                                          >
                                                            <span className="text-white">
                                                              Add More
                                                              Participants
                                                            </span>
                                                          </Link>
                                                        </div>
                                                      )}
                                                  </td>
                                                  <td className="font-small fontItalic text-dark adminNotes text-center fs-12">
                                                    {item.adminNotes
                                                      ? item.adminNotes
                                                      : "-"}
                                                  </td>
                                                  <td className="font-small fontItalic text-center text-secondary fs-12">
                                                    <ModuleDisplayDateTime
                                                      value={item.createdAt}
                                                    />
                                                  </td>
                                                </tr>

                                                {item.additionalRequests &&
                                                  item.additionalRequests
                                                    .length > 0 &&
                                                  item.additionalRequests.map(
                                                    (request, index) => {
                                                      return (
                                                        <tr
                                                          className={`bg-table ${
                                                            index + 1 ===
                                                            item
                                                              .additionalRequests
                                                              .length
                                                              ? "borderBottom"
                                                              : ""
                                                          } `}
                                                        >
                                                          <td className="text-center">
                                                            <>
                                                              {request.memberStatus ===
                                                              "1" ? (
                                                                <Badge bg="success">
                                                                  Confirmed
                                                                </Badge>
                                                              ) : request.memberStatus ===
                                                                "0" ? (
                                                                <Badge
                                                                  bg="warning"
                                                                  text="dark"
                                                                >
                                                                  Payment
                                                                  Pending
                                                                </Badge>
                                                              ) : (
                                                                "-"
                                                              )}
                                                            </>
                                                          </td>

                                                          {/* Partner group */}
                                                          {showPartnerGroup && (
                                                            <>
                                                              <td className="text-center">
                                                                <>
                                                                  {request.partnerParticipating ===
                                                                  "1" ? (
                                                                    <Badge bg="success">
                                                                      Yes
                                                                    </Badge>
                                                                  ) : (
                                                                    "-"
                                                                  )}
                                                                </>
                                                              </td>
                                                              <td className="text-center">
                                                                <>
                                                                  {request.partnerStatus ===
                                                                  "1" ? (
                                                                    <Badge bg="success">
                                                                      Confirmed
                                                                    </Badge>
                                                                  ) : request.partnerParticipating ===
                                                                      "1" &&
                                                                    request
                                                                      ?.payment
                                                                      ?.partnerParticipationFee >
                                                                      0 ? (
                                                                    <Badge
                                                                      bg="warning"
                                                                      text="dark"
                                                                    >
                                                                      Payment
                                                                      Pending
                                                                    </Badge>
                                                                  ) : request.partnerParticipating ===
                                                                    "1" ? (
                                                                    <Badge
                                                                      bg="warning"
                                                                      text="dark"
                                                                    >
                                                                      Pending
                                                                    </Badge>
                                                                  ) : (
                                                                    "-"
                                                                  )}
                                                                </>
                                                              </td>
                                                            </>
                                                          )}

                                                          {/* Guest group */}
                                                          {showGuestGroup && (
                                                            <>
                                                              <td className="text-center">
                                                                {request.guestParticipating ===
                                                                "1" ? (
                                                                  guestRequiresApproval ? (
                                                                    <Badge bg="success">
                                                                      Yes -
                                                                      Requested
                                                                      (
                                                                      {
                                                                        request.reqNumberOfGuestParticipating
                                                                      }
                                                                      )
                                                                    </Badge>
                                                                  ) : (
                                                                    <Badge bg="success">
                                                                      Yes (
                                                                      {
                                                                        request.reqNumberOfGuestParticipating
                                                                      }
                                                                      )
                                                                    </Badge>
                                                                  )
                                                                ) : (
                                                                  "-"
                                                                )}
                                                              </td>
                                                              {guestRequiresApproval && (
                                                                <td className="text-center">
                                                                  <ApprovalBadge
                                                                    status={
                                                                      request?.guestApprovalStatus
                                                                    }
                                                                    value={`
                                                                      ${request?.guestApprovalStatus} (${request?.NumberOfGuestParticipating})
                                                                      `}
                                                                  />
                                                                </td>
                                                              )}
                                                              <td className="text-center">
                                                                {request.guestParticipating ===
                                                                "1" ? (
                                                                  <>
                                                                    {request.isRejected ===
                                                                      "1" && (
                                                                      <Badge bg="danger">
                                                                        Rejected
                                                                      </Badge>
                                                                    )}
                                                                    {request.isApprovedByAdmin ===
                                                                      "1" && (
                                                                      <>
                                                                        {request.guestStatus ===
                                                                        "1" ? (
                                                                          <Badge bg="success">
                                                                            {" "}
                                                                            Confirmed{" "}
                                                                          </Badge>
                                                                        ) : request
                                                                            ?.payment
                                                                            ?.guestParticipationFee >
                                                                          0 ? (
                                                                          <Badge
                                                                            bg="warning"
                                                                            text="dark"
                                                                          >
                                                                            {" "}
                                                                            Payment
                                                                            Pending{" "}
                                                                          </Badge>
                                                                        ) : (
                                                                          <Badge
                                                                            bg="warning"
                                                                            text="dark"
                                                                          >
                                                                            Pending{" "}
                                                                          </Badge>
                                                                        )}
                                                                      </>
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  "-"
                                                                )}
                                                              </td>
                                                            </>
                                                          )}

                                                          {/* Kids group */}
                                                          {showKidsGroup && (
                                                            <>
                                                              <td className="text-center">
                                                                {request.kidsParticipating ===
                                                                "1" ? (
                                                                  kidsRequiresApproval ? (
                                                                    <Badge bg="success">
                                                                      Yes -
                                                                      Requested
                                                                      (
                                                                      {
                                                                        request.reqNumberOfKidsParticipating
                                                                      }
                                                                      )
                                                                    </Badge>
                                                                  ) : (
                                                                    <Badge bg="success">
                                                                      Yes (
                                                                      {
                                                                        request.reqNumberOfKidsParticipating
                                                                      }
                                                                      )
                                                                    </Badge>
                                                                  )
                                                                ) : (
                                                                  "-"
                                                                )}
                                                              </td>
                                                              {kidsRequiresApproval && (
                                                                <td className="text-center">
                                                                  <ApprovalBadge
                                                                    status={
                                                                      request?.kidApprovalStatus
                                                                    }
                                                                    value={`
                                                                      ${request?.kidApprovalStatus} (${request?.NumberOfKidsParticipating})
                                                                    `}
                                                                  />
                                                                </td>
                                                              )}
                                                              <td className="text-center">
                                                                {request.kidsParticipating ===
                                                                "1" ? (
                                                                  <>
                                                                    {request.isRejected ===
                                                                      "1" && (
                                                                      <Badge bg="danger">
                                                                        Rejected
                                                                      </Badge>
                                                                    )}
                                                                    {request.isApprovedByAdmin ===
                                                                      "1" && (
                                                                      <>
                                                                        {request.kidsStatus ===
                                                                        "1" ? (
                                                                          <Badge bg="success">
                                                                            {" "}
                                                                            Confirmed{" "}
                                                                          </Badge>
                                                                        ) : request
                                                                            ?.payment
                                                                            ?.kidsParticipationFee >
                                                                          0 ? (
                                                                          <Badge
                                                                            bg="warning"
                                                                            text="dark"
                                                                          >
                                                                            {" "}
                                                                            Payment
                                                                            Pending{" "}
                                                                          </Badge>
                                                                        ) : (
                                                                          <Badge
                                                                            bg="warning"
                                                                            text="dark"
                                                                          >
                                                                            Pending{" "}
                                                                          </Badge>
                                                                        )}
                                                                      </>
                                                                    )}
                                                                  </>
                                                                ) : (
                                                                  "-"
                                                                )}
                                                              </td>
                                                            </>
                                                          )}

                                                          <td className="d-flex align-items-center flex-column justify-content-center">
                                                            {request.isCreatedByAdmin ===
                                                            "1" ? (
                                                              <>
                                                                {(request.status ===
                                                                  "0" ||
                                                                  (request.status ===
                                                                    "1" &&
                                                                    request
                                                                      .payment
                                                                      .paidAmount <=
                                                                      0)) && (
                                                                  <div className="d-flex align-items-center justify-content-center">
                                                                    <Link
                                                                      title="Cancel"
                                                                      onClick={() =>
                                                                        confirmAndRemoveRegistration(
                                                                          {
                                                                            activityId:
                                                                              id,
                                                                            memberId:
                                                                              item.memberId,
                                                                            registrationId:
                                                                              "",
                                                                            additionalRequestId:
                                                                              request._id,
                                                                          },
                                                                        )
                                                                      }
                                                                      className="btn btn-danger acceptButton  border me-1"
                                                                    >
                                                                      <i className="fas fa-times text-white me-1"></i>{" "}
                                                                      <span className="text-white">
                                                                        Cancel
                                                                      </span>
                                                                    </Link>
                                                                  </div>
                                                                )}
                                                              </>
                                                            ) : (
                                                              <>
                                                                {request.status ===
                                                                  "1" &&
                                                                  request.isApprovedByAdmin ===
                                                                    "1" &&
                                                                  request.partnerParticipating ===
                                                                    "0" && (
                                                                    <>
                                                                      <div className="adminApproved red text-success">
                                                                        Actions
                                                                        not
                                                                        available
                                                                        {parseInt(
                                                                          request
                                                                            ?.payment
                                                                            ?.paidAmount,
                                                                        ) > 0
                                                                          ? " - Payment is Done"
                                                                          : ""}
                                                                      </div>
                                                                    </>
                                                                  )}
                                                                {request.isRejected ===
                                                                  "1" && (
                                                                  <>
                                                                    <div className="adminApproved red text-danger px-2">
                                                                      Admin
                                                                      rejected
                                                                      this
                                                                      request
                                                                    </div>
                                                                  </>
                                                                )}

                                                                {request.isApprovedByAdmin ===
                                                                  "1" &&
                                                                  request.partnerParticipating ===
                                                                    "1" && (
                                                                    <>-</>
                                                                  )}

                                                                {request.status ===
                                                                  "0" &&
                                                                  request.isRejected !=
                                                                    "1" && (
                                                                    <>
                                                                      <div className="d-flex align-items-center justify-content-center">
                                                                        <Link
                                                                          title="Accept"
                                                                          onClick={() => {
                                                                            showModal(
                                                                              request,
                                                                              "accept",
                                                                            );
                                                                          }}
                                                                          className={`btn acceptButton border me-1 
                                                                              ${request.isApprovedByAdmin == "1" ? "btn-info" : "btn-success"}`}
                                                                        >
                                                                          {request.isApprovedByAdmin ==
                                                                          "1" ? (
                                                                            <i className="fas fa-edit text-white me-1"></i>
                                                                          ) : (
                                                                            <i className="fas fa-check text-white me-1"></i>
                                                                          )}

                                                                          <span className="text-white">
                                                                            {request.isApprovedByAdmin ==
                                                                            "1"
                                                                              ? "Modify"
                                                                              : " Accept"}
                                                                          </span>
                                                                        </Link>
                                                                      </div>

                                                                      {request.isRejected !=
                                                                        "1" &&
                                                                        request.isApprovedByAdmin !=
                                                                          "1" && (
                                                                          <div className="d-flex align-items-center justify-content-center">
                                                                            <Link
                                                                              title="Reject"
                                                                              onClick={() => {
                                                                                showModal(
                                                                                  request,
                                                                                  "reject",
                                                                                );
                                                                              }}
                                                                              className="btn btn-danger acceptButton  border me-1"
                                                                            >
                                                                              <i className="fas fa-times text-white me-1"></i>{" "}
                                                                              <span className="text-white">
                                                                                Reject
                                                                              </span>
                                                                            </Link>
                                                                          </div>
                                                                        )}
                                                                    </>
                                                                  )}
                                                              </>
                                                            )}
                                                          </td>

                                                          <td className="font-small fontItalic text-dark text-center fs-12">
                                                            {request.adminNotes
                                                              ? request.adminNotes
                                                              : "-"}
                                                          </td>
                                                          <td className="font-small fontItalic text-secondary fs-12 text-center">
                                                            <ModuleDisplayDateTime
                                                              value={
                                                                request.createdAt
                                                              }
                                                            />
                                                          </td>
                                                        </tr>
                                                      );
                                                    },
                                                  )}
                                              </>
                                            );
                                          },
                                        )}
                                      </tbody>
                                    </Table>
                                  </div>
                                </>
                              )}
                          </>
                        )}
                      </section>

                      <ListingFooter
                        listingState={listingState}
                        moduleConfig={moduleConfig}
                        isCheck={isCheck}
                        setFilter={setFilter}
                      />

                      {actionItem && (
                        <AdditionalRequestAcceptModal
                          show={showAdditionalRequestAcceptModal}
                          setShow={setShowAdditionalRequestAcceptModal}
                          loadItems={loadItems}
                          item={actionItem}
                        />
                      )}

                      {actionItem && (
                        <AdditionalRequestRejectModal
                          show={showAdditionalRequestRejectModal}
                          setShow={setShowAdditionalRequestRejectModal}
                          loadItems={loadItems}
                          item={actionItem}
                        />
                      )}
                    </>
                  ) : (
                    <Alert variant="warning">No records found.</Alert>
                  )}
                  {listingState.data && (
                    <RegisterNewModal
                      show={showRegisterNewModal}
                      setShow={setShowRegisterNewModal}
                      loadItems={loadItems}
                      id={id}
                      activity={screen.item}
                      members={screen.members}
                    />
                  )}
                  {udpateItem && listingState.data && (
                    <AddMoreParticipantsModal
                      show={showAddMoreParticipantsModal}
                      setShow={setShowAddMoreParticipantsModal}
                      loadItems={loadItems}
                      id={id}
                      data={udpateItem}
                    />
                  )}
                </div>
              </>
            )}
          </>
        )}
    </DashboardLayout>
  );
};

export default ActivityRegistrationsListing;
